import { useLayoutEffect } from 'react';
import { scheduleScrollPageToTop } from '../utils/scrollPageToTop.js';

/**
 * Jump to the top of the page when `key` changes (route, in-app step, nested view).
 * Layout effect so the new screen is not painted at the previous scroll offset.
 */
export function useScrollToTopOnChange(key) {
  useLayoutEffect(() => {
    const rafId = scheduleScrollPageToTop();
    return () => {
      if (rafId && typeof cancelAnimationFrame === 'function') {
        cancelAnimationFrame(rafId);
      }
    };
  }, [key]);
}
